// extracted by mini-css-extract-plugin
var _1 = "SM1hdUXkfPOVUPloDjbc";
export { _1 as "container" }
